import $ from 'jquery';
import { readCookie, createCookie } from '../utils/cookie.js';

jQuery(document).ready(function($) {
    $('.cards-list .card').click(function() {
        $(this).addClass('active');
        $('.cards-list .card').not(this).addClass('inactive');

        var clickedCards = readCookie('clickedCards');
        if (clickedCards) {
            // Parse the existing cookie value and append the new card ID
            clickedCards = JSON.parse(clickedCards);
        } else {
            // Initialize a new array if the cookie doesn't exist
            clickedCards = [];
        }

        // Add the new clicked card ID if it's not already in the array
        if (!clickedCards.includes($(this).attr('id'))) {
            clickedCards.push($(this).attr('id'));
        }

        // Calculate the expiration time
        var currentDate = new Date();
        var midnight = new Date(currentDate);
        midnight.setDate(currentDate.getDate() + 1);
        midnight.setHours(0, 0, 0, 0);
        var timeUntilMidnightInDays = (midnight.getTime() - currentDate.getTime()) / (1000 * 60 * 60 * 24);

        // Update the cookie with the new array of clicked card IDs
        createCookie('clickedCards', JSON.stringify(clickedCards), timeUntilMidnightInDays);
    });


    // $('.cards-list .card').click(function() {
    //     var cardId = $(this).attr('id'); 

    //     $.ajax({
    //         url: ajax.ajax.url,
    //         nonce: ajax.ajax.nonce,
    //         type: 'POST',
    //         data: {
    //             'action': 'update_user_interaction',
    //         },
    //         success: function(response) {
    //             console.log('User interaction updated: ' + response);
    //         },
    //         error: function(error) {
    //             console.log('Error updating user interaction: ' + error);
    //         }
    //     });
    // }); 

    // $('.cards-list .card').click(function(){
    //     if($('.cards-list .active').length > 0) {
    //         // Prevent interaction if already interacted without purchase.
    //         return;
    //     }
    
    //     // Interaction logic, assume checkPurchaseStatus is a function to determine if a purchase was made.
    //     if (checkPurchaseStatus() || $('.cards-list .active').length < 5) {
    //         $(this).removeClass('inactive').addClass('active');
    
    //         // Assuming createCookie handles the interaction counting and expiry.
    //         createCookie('clickedCard', $(this).attr('id'), 1); // Expires in 1 day
    //     }
    // });
  
});



// WEBPACK FOOTER //
// ./resources/assets/js/partials/cards.js